<hlm-form-field class="w-full">
  <label hlmLabel [for]="control">
    {{ label }}

    @if (required()) {
      <span class="text-primary">*</span>
    }
  </label>

  <brn-select class="inline-block w-full" [placeholder]="placeholder" [formControlName]="control">
    <hlm-select-trigger class="w-full">
      <hlm-select-value/>
    </hlm-select-trigger>
    <hlm-select-content class="bg-background">
      @for (option of options; track option) {
        <hlm-option [value]="option.value">{{ option.label }}</hlm-option>
      }
    </hlm-select-content>
  </brn-select>

  <hlm-error [control]="control" class="text-xs"/>

  @if (hint) {
    <hlm-hint>{{ hint }}</hlm-hint>
  }
</hlm-form-field>

